// Rebuy's cart drawer has no way to reach the full cart page: add a link under its "Your cart" heading.
// Rebuy redraws the drawer on every cart change, so the link is put back whenever it goes missing.
// `disable-rebuy` stops Rebuy from turning a /cart link into "open the drawer" (it cancels the click otherwise).
(() => {
  const { cartUrl, label } = document.currentScript.dataset;
  const MISSING = '.rebuy-cart__flyout [data-rebuy-cart-header-top]:not(:has(+ .rebuy-cart__view-cart))';

  const addLink = () => {
    document.querySelectorAll(MISSING).forEach((header) => {
      const link = document.createElement('a');
      link.className = 'rebuy-cart__view-cart disable-rebuy';
      link.href = cartUrl;
      link.textContent = label;
      header.after(link);
    });
  };

  new MutationObserver(addLink).observe(document.body, { childList: true, subtree: true });
  addLink();
})();
